import { lazyLoad } from 'utils/loadable';
import LoadingSpinner from 'app/components/Loading/LoadingSpinner';

export const QuotesPage = lazyLoad(
    () => import('./index'),
    module => module.QuotesPage,
    { fallback: <LoadingSpinner /> },
);
